const Clinicas = () => <div><h3>🏥 Gestión de Clínicas</h3></div>;
export default Clinicas;